// src/App.js
import React from 'react';
import MarkdownEditor from './components/MarkdownEditor';

function App() {
  return (
    <div className="App">
    <MarkdownEditor />
    </div>
  );
}

export default App;
